import React, { useState, useEffect } from 'react';
import { HiChevronLeft, HiChevronRight, HiUsers, HiGlobe, HiLightBulb, HiScale } from 'react-icons/hi';
import { 
  GlobeAltIcon, 
  TruckIcon, 
  WrenchScrewdriverIcon,
  ShieldCheckIcon,
  LifebuoyIcon,
  ClipboardDocumentCheckIcon
} from '@heroicons/react/24/outline';
import slide2 from '../../Assets/images/01.jpg';
import slide1 from '../../Assets/images/02.jpg';
import slide3 from '../../Assets/images/03.jpg';
import slide4 from '../../Assets/images/04.jpg';
import partner1 from '../../Assets/images/partner1.avif';
import partner2 from '../../Assets/images/partner1.avif';
import partner3 from '../../Assets/images/partner1.avif';
import partner4 from '../../Assets/images/partner1.avif';
import partner5 from '../../Assets/images/partner1.avif';
import partner6 from '../../Assets/images/partner1.avif';
import { Link } from 'react-router-dom';

function Home() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [resetTimer, setResetTimer] = useState(0);

  const slides = [
    {
      image: slide1,
      title: 'Marine Port Services',
      description: 'Over 20 years of experience in professional maritime and port services'
    },
    {
      image: slide2,
      title: 'Reliable Solutions',
      description: 'We are by your side with our modern equipment and expert staff'
    },
    {
      image: slide3,
      title: 'Global Service Network',
      description: 'Worldwide port and logistics services'
    },
    {
      image: slide4,
      title: 'Professional Team',
      description: 'Expert staff providing quality service in all ports'
    }
  ];

  const partners = [
    { name: "Partner 1", logo: partner1 },
    { name: "Partner 2", logo: partner2 },
    { name: "Partner 3", logo: partner3 },
    { name: "Partner 4", logo: partner4 },
    { name: "Partner 5", logo: partner5 },
    { name: "Partner 6", logo: partner6 },
  ];

  const services = [
    // {
    //   icon: LifebuoyIcon,
    //   title: "Port Services",
    //   description: "Professional port services including berthing, unberthing, and cargo operations",
    //   link: "/services/port"
    // },
    {
      icon: ClipboardDocumentCheckIcon,
      title: "VDR / SVDR Annual Testing",
      description: "Comprehensive VDR/SVDR performance testing and certification services with manufacturer approved procedures",
      link: "/services/vdr"
    },
    // {
    //   icon: GlobeAltIcon,
    //   title: "Ship Management",
    //   description: "Complete vessel management solutions for efficient maritime operations",
    //   link: "/services/ship-management"
    // },
    // {
    //   icon: TruckIcon,
    //   title: "Logistics Solutions",
    //   description: "Integrated logistics services for seamless cargo transportation",
    //   link: "/services/logistics"
    // },
    {
      icon: WrenchScrewdriverIcon,
      title: "Technical Services",
      description: "Expert technical support and maintenance for marine vessels",
      link: "/services/technical"
    },
    {
      icon: ShieldCheckIcon,
      title: "Safety & Compliance",
      description: "Ensuring maritime safety and regulatory compliance",
      link: "/services/safety"
    }
  ];

  const values = [
    {
      icon: <HiUsers className="w-8 h-8" />,
      title: "Customer Focus",
      description: "We develop solutions by best understanding our customers' needs."
    },
    {
      icon: <HiGlobe className="w-8 h-8" />,
      title: "Global Service",
      description: "We are by your side at every point with our worldwide service network."
    },
    {
      icon: <HiLightBulb className="w-8 h-8" />,
      title: "Innovation",
      description: "We update our services by following continuously evolving technologies."
    },
    {
      icon: <HiScale className="w-8 h-8" />,
      title: "Reliability",
      description: "We provide quality service with transparent and reliable business processes."
    }
  ];

  
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
    }, 5000);

    return () => clearInterval(timer);
  }, [resetTimer]); 

 
  const resetSlideTimer = () => {
    setResetTimer(prev => prev + 1);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
    resetSlideTimer(); 
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
    resetSlideTimer(); 
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
    resetSlideTimer();
  };

  return (
    <div>
      <div className="relative h-[600px] md:h-[800px] overflow-hidden">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-all duration-1000 ease-in-out
              ${index === currentSlide ? 'opacity-100 z-10' : 'opacity-0 z-0'}`}
          >
            <img
              src={slide.image}
              alt={slide.title}
              className={`w-full h-full object-cover transition-transform duration-[8000ms] ease-in-out
                ${index === currentSlide ? 'scale-110' : 'scale-100'}`}
            />
            <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
              <div className="text-center text-white space-y-6 px-4 max-w-4xl mx-auto">
                <h1 className="text-4xl md:text-6xl font-bold font-tt-lakes">
                  {slide.title}
                </h1>
                <p className="text-lg md:text-xl">
                  {slide.description}
                </p>
                
              </div>
            </div>
          </div>
        ))}

        <button
          onClick={prevSlide}
          className="absolute left-4 top-1/2 -translate-y-1/2 z-20 bg-black/50 hover:bg-marine-red text-white p-2 rounded-full transition-all duration-300 group"
        >
          <HiChevronLeft className="w-6 h-6 group-hover:scale-110" />
        </button>
        
        <button
          onClick={nextSlide}
          className="absolute right-4 top-1/2 -translate-y-1/2 z-20 bg-black/50 hover:bg-marine-red text-white p-2 rounded-full transition-all duration-300 group"
        >
          <HiChevronRight className="w-6 h-6 group-hover:scale-110" />
        </button>

        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20">
          <div className="flex items-center space-x-3">
            {slides.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`w-3 h-3 rounded-full transition-all duration-300 
                  ${currentSlide === index 
                    ? 'bg-marine-red scale-125' 
                    : 'bg-white/50 hover:bg-marine-red'}`}
              />
            ))}
          </div>
        </div>
      </div>

      <div className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-marine-black mb-4">
              Our Services
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Comprehensive maritime solutions tailored to meet your specific needs with our expert team and modern equipment
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div 
                key={index}
                className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
              >
                <div className="flex flex-col items-center text-center">
                  <div className="w-16 h-16 bg-red-50 rounded-full flex items-center justify-center mb-6">
                    <service.icon className="w-8 h-8 text-marine-red" />
                  </div>
                  <h3 className="text-xl font-bold text-marine-black mb-4">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 mb-6">
                    {service.description}
                  </p>
                  {/* <a 
                    href={service.link}
                    className="text-marine-red hover:text-red-700 font-medium flex items-center transition-colors duration-300"
                  >
                    Learn More
                    <svg 
                      className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform duration-300" 
                      fill="none" 
                      viewBox="0 0 24 24" 
                      stroke="currentColor"
                    >
                      <path 
                        strokeLinecap="round" 
                        strokeLinejoin="round" 
                        strokeWidth={2} 
                        d="M9 5l7 7-7 7" 
                      />
                    </svg>
                  </a> */}
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-16">
            <Link
              to="/services" 
              className="inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-full text-white bg-marine-red hover:bg-red-700 transition-colors duration-300"
            >
              View All Services
            </Link>
          </div>
        </div>
      </div>

      <div className="py-16 bg-gradient-to-br from-gray-900 to-marine-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-white text-center mb-12">
            Our Values
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div 
                key={index}
                className="bg-white/10 backdrop-blur-sm p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300 text-white border border-white/20"
              >
                <div className="text-marine-red mb-4">
                  {value.icon}
                </div>
                <h3 className="text-xl font-bold text-marine-red mb-2">
                  {value.title}
                </h3>
                <p className="text-white/80">
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      
    </div>
  );
}

export default Home;